import theme from 'config/theme';

export const B2B_STATUSES = {
  new: {
    label: 'New',
    value: 0,
    styles: {
      backgroundColor: theme.palette.blues.primaryBlue,
      color: '#FFFFFF',
    },
  },
  inProgress: {
    label: 'In Progress',
    value: 1,
    styles: {
      backgroundColor: theme.palette.grays.gray200,
      color: theme.palette.limes.lime900,
    },
  },
  creditCheck: {
    label: 'Credit Check',
    value: 2,
    styles: {
      backgroundColor: theme.palette.purples.secondaryPurple,
      color: '#FFFFFF',
    },
  },
  cancelled: {
    label: 'Cancelled',
    value: 3,
    styles: {
      backgroundColor: theme.palette.reds.codingRed400,
      color: '#FFFFFF',
    },
  },
  done: {
    label: 'Done',
    value: 4,
    styles: {
      backgroundColor: theme.palette.limes.lime200,
      color: theme.palette.limes.lime900,
    },
  },
};
